import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useOnboarding } from '../../../context/OnboardingContext';
import { PrivateWizardLayout, WizardContainer, WizardCard, WizardActions } from '../WizardLayout';
import Stepper from '../Stepper';
import { toast } from 'react-toast';
import { LuPencil, LuArrowLeft, LuChevronDown, LuInfo, LuSkipForward } from 'react-icons/lu';
import { WizardSelect } from '../onboarding';
import OnboardingModal from '../onboarding/OnboardingModal';
import axiosInstance from '../../../api/axiosInstance';
import '../../../styles/wizard.css';
import ConfirmAppTypeModal from '../modals/ConfirmAppTypeModal';
import { STEP_MODE, STEP_STATUS } from '../../../Config/Onboarding/constant';

  const deviceCategoryMap = {
    smart_lock: 1,
    sensor: 2,
    switch: 3,
    camera: 4,
    controller: 5,
    other: 6,
    // add 7 if you know what it maps to
  };

  const testEnvironmentMap = {
    lab: 1,
    field: 2,
    hybrid: 3,
  };

  const APP_TYPE_LABELS = {
    web: 'Web Application',
    API_BACKEND: 'API / Backend',
    mobile: 'Mobile Application',
    iot_hardware: 'IoT / Hardware',
  };

  const connectivityMap = {
    wifi: 1,
    ble: 2,
    zigbee: 3,
    ethernet: 4,
    lora: 5,
    other: 6,
  };

const Step3Project = () => {
  const navigate = useNavigate();
  const { 
    engine, 
    data, 
    nextStep, 
    previousStep, 
    setProject,
    setStepStatus,
    setStepMode,
    setStepEditing,
    setStepCreatedEntityId,
    markStepCompleted,
    updateStepFlowByAppType,
    state
  } = useOnboarding();
  
  const stepId = 3;
  const stepState = engine.steps[stepId];

//   if (!stepState) {
//   return null; // or a loading spinner
// }

  const projectData = data.project;
  
  // Determine step statuses
  const isCreating = !(projectData.project_id && projectData.environment_id);
  const isEditMode = stepState?.status === STEP_STATUS.COMPLETED && stepState?.mode === STEP_MODE.EDIT;
  const isEditingProject = stepState?.isEditing === true && stepState?.editingSection === 'project';
  const isEditingEnvironment = stepState?.isEditing === true && stepState?.editingSection === 'environment';
  
  // Show edit icons only when both project_id and environment_id exist
  const showEditIcons = projectData.project_id && projectData.environment_id;
  
  // Inputs should be disabled only when NOT in CREATE or NOT in EDITING mode
 
  const isEnvironmentFieldsDisabled = !isCreating && !isEditingEnvironment;

  // State for multi-step form progression
  const [currentSection, setCurrentSection] = useState('project'); // 'project', 'bitbucket', 'repository'
  const [projectId, setProjectId] = useState(projectData.project_id || null);
  const [environmentId, setEnvironmentId] = useState(projectData.environment_id || null);

  // Completion and edit mode states for each section
  const [isProjectCompleted, setIsProjectCompleted] = useState(!!projectData.project_id);
  const [isBitbucketCompleted, setIsBitbucketCompleted] = useState(!!projectData.bitbucketUsername);
  const [isRepositoryCompleted, setIsRepositoryCompleted] = useState(!!projectData.selectedRepository);
  const [isEditingBitbucket, setIsEditingBitbucket] = useState(false);
  const [isEditingRepository, setIsEditingRepository] = useState(false);
  const [showAppTypeModal, setShowAppTypeModal] = useState(false);
  const [pendingAppType, setPendingAppType] = useState('');
  const [isAppTypeLocked, setIsAppTypeLocked] = useState(!!projectData.applicationType);

   
  const isProjectFieldsDisabled = !isCreating && !isEditingProject;

  const [formData, setFormData] = useState({
    name: projectData.name || '',
    applicationType: projectData.applicationType || '',
    environment: projectData.environment || 'dev',
    baseUrl: projectData.baseUrl || '',
    apiBaseUrl: projectData.apiBaseUrl || '',
    appPackage: projectData.appPackage || '',
    // IoT-specific fields
    iotCategory: projectData.iotCategory || '',
    iotConnectivity: projectData.iotConnectivity || '',
    iotTestEnvironment: projectData.iotTestEnvironment || ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // Bitbucket credentials state
  const [bitbucketUsername, setBitbucketUsername] = useState(projectData.bitbucketUsername || '');
  const [bitbucketAppPassword, setBitbucketAppPassword] = useState(projectData.bitbucketAppPassword || '');
  const [bitbucketErrors, setBitbucketErrors] = useState({});

  // Workspace and repository state
  const [workspaces, setWorkspaces] = useState([]);
  const [repositories, setRepositories] = useState([]);
  const [selectedWorkspace, setSelectedWorkspace] = useState(projectData.selectedWorkspace || '');
  const [selectedRepository, setSelectedRepository] = useState(projectData.selectedRepository || '');
  const [fetchingWorkspaces, setFetchingWorkspaces] = useState(false);
  const [fetchingRepos, setFetchingRepos] = useState(false);
  const [repositoryErrors, setRepositoryErrors] = useState({});

  // Skip Bitbucket flow state
  const [showSkipBitbucketModal, setShowSkipBitbucketModal] = useState(false);

  // Fetch workspaces when entering repository section and sync saved values
  useEffect(() => {
    if (currentSection === 'repository') {
      fetchWorkspaces();
      if(selectedWorkspace){
      fetchRepositories(selectedWorkspace);
      }

      
      // Prefill with saved workspace and repository if they exist
      if (projectData.selectedWorkspace && !selectedWorkspace) {
        setSelectedWorkspace(projectData.selectedWorkspace);
      }
      if (projectData.selectedRepository && !selectedRepository) {
        setSelectedRepository(projectData.selectedRepository);
      }
    }
    else{
      setRepositories([]);
      setSelectedRepository('');
    }
  }, [currentSection,selectedWorkspace]);

  // Fetch repositories when workspace changes
  // useEffect(() => {
  //   if (selectedWorkspace   ) {
  //      fetchWorkspaces();

  //     fetchRepositories(selectedWorkspace);
  //   } else {

  //   }
  // }, [selectedWorkspace]);

    const handleChange = (e) => {
      const { name, value } = e.target;

      if (name === 'applicationType') {
        setPendingAppType(value);
        setShowAppTypeModal(true);
        return;
      }

      setFormData(prev => ({ ...prev, [name]: value }));

      if (errors[name]) {
        setErrors(prev => ({ ...prev, [name]: '' }));
      }
    
  
  // if (name === 'applicationType' && value) {
  //   setProject({ applicationType: value }); // ← keeps data.project in sync for non-IoT too
  //   updateStepFlowByAppType(value);          // ← only acts for iot_hardware
  // }
    };

  const fetchWorkspaces = async () => {
    setFetchingWorkspaces(true);
    try {
      const response = await axiosInstance.get('/git_workspaces');
      if (response.data && Array.isArray(response.data)) {
        setWorkspaces(response.data);
      }
    } catch (error) {
      console.error('Error fetching workspaces:', error);
      toast.error('Failed to load workspaces', {
        position: 'top-right',
        duration: 3000,
      });
    } finally {
      setFetchingWorkspaces(false);
    }
  };

        const saveWizardData = async () => {
      try {
        await axiosInstance.post('/wizard/add_wizard_data', {
          wizard_data: {
            engine: engine,
            data: state.data
          }
        });
      } catch (error) {
      }
    };

  const fetchRepositories = async (workspaceSlug) => {
    setFetchingRepos(true);
    setRepositories([]);
    try {
      const response = await axiosInstance.get(`/list_workspace_repos?workspace=${workspaceSlug}`);
      if (response.data && Array.isArray(response.data)) {
        setRepositories(response.data);
      }
    } catch (error) {
      console.error('Error fetching repositories:', error);
      toast.error('Failed to load repositories', {
        position: 'top-right',
        duration: 3000,
      });
    } finally {
      setFetchingRepos(false);
    }
  };

  const validate = (section = 'all') => {
    const newErrors = {};
    
    // Project validation
    if (section === 'all' || section === 'project') {
      if (!formData.name.trim()) {
        newErrors.name = 'Project name is required';
      }
      if (!formData.applicationType) {
        newErrors.applicationType = 'Application type is required';
      }
    }
    
    // Environment validation
    if (section === 'all' || section === 'environment') {
      if (!formData.environment) {
        newErrors.environment = 'Environment is required';
      }
      
      // Conditional validation based on app type
      if (formData.applicationType === 'web' && !formData.baseUrl.trim()) {
        newErrors.baseUrl = 'Base URL is required for web applications';
      }
      if (formData.applicationType === 'api' && !formData.apiBaseUrl.trim()) {
        newErrors.apiBaseUrl = 'API Base URL is required for API testing';
      }
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 const createProjectAPI = async () => {

  const basePayload = {
    project_name: formData.name,
    is_wizard: true,
    workspace_id: data.workspace.id,
    description: ''
  };

  const applicationTypeConfig = {
    web: {
      project_type: 'WEB',
    },
    API_BACKEND: {
      project_type: 'API_BACKEND',
    },
    iot_hardware: {
      project_type: 'IOT',
      device_category: deviceCategoryMap[formData.iotCategory] ?? null,
      connectivity_type: connectivityMap[formData.iotConnectivity] ?? null,
      test_environment: testEnvironmentMap[formData.iotTestEnvironment] ?? null,
    },
  };

  const selectedConfig = applicationTypeConfig[formData.applicationType] || {};

  const payload = { ...basePayload, ...selectedConfig };

  try {
    const response = await axiosInstance.post('/projects/add_project', payload);
    if (response.project_id) {
      return response.project_id;
    }
    throw new Error('Failed to get project_id from response');
  } catch (error) {
    console.error('Error creating project:', error);
    throw error;
  }
};

  const createEnvironmentAPI = async (projectId) => {
    try {
      const environmentUrl = formData.applicationType === 'web' 
        ? formData.baseUrl 
        : formData.applicationType === 'API_BACKEND'
        ? formData.apiBaseUrl
        : '';

      const response = await axiosInstance.post('/user_profile/add_environment_setting', {
        project_id: projectId,
        environment_name: formData.environment,
        environment_description: `${formData.environment} environment`,
        url: environmentUrl,
        environment_data: [],
        is_wizard: true
      });

      if (response.environment_id) {
        return response.environment_id;
      }
      throw new Error('Failed to get environment_id from response');
    } catch (error) {
      console.error('Error creating environment:', error);
      throw error;
    }
  };

  const updateProjectAPI = async (projectId) => {
    try {
      const response = await axiosInstance.put(`/projects/update_project?project_id=${projectId}`, {
        project_name: formData.name,
        description: '',
        project_type: formData.applicationType.toUpperCase(),
        status: 'active',
        is_wizard: true
      });

      if (response.project_id) {
        setProject({
          name: formData.name,
          applicationType: formData.applicationType,
        });
        return response.project_id;
      }
      throw new Error('Failed to update project');
    } catch (error) {
      console.error('Error updating project:', error);
      throw error;
    }
  };

  const updateEnvironmentAPI = async (environmentId) => {
    try {
      const environmentUrl = formData.applicationType === 'web' 
        ? formData.baseUrl 
        : formData.applicationType === 'API_BACKEND'
        ? formData.apiBaseUrl
        : '';

      const response = await axiosInstance.put('/user_profile/update_environment', {
        env_id: environmentId,
        project_id: projectData.project_id,
        environment_name: formData.environment,
        environment_description: `${formData.environment} environment`,
        url: environmentUrl,
        is_wizard: true,
        environment_data: []
      });

      if (response.environment_id) {
        setProject({
          environment: formData.environment,
          baseUrl: formData.baseUrl,
          apiBaseUrl: formData.apiBaseUrl,
          appPackage: formData.appPackage,
          iotCategory: formData.iotCategory,
          iotConnectivity: formData.iotConnectivity,
          iotTestEnvironment: formData.iotTestEnvironment,
        });
        return response.environment_id;
      }
      throw new Error('Failed to update environment');
    } catch (error) {
      console.error('Error updating environment:', error);
      throw error;
    }
  };

  const handleSaveAndNext = async () => {
    if (!validate()) return;

    setIsLoading(true);
    try {
      // Step 1: Create project
      const newProjectId = await createProjectAPI();
      
      // Step 2: Create environment
      const newEnvironmentId = await createEnvironmentAPI(newProjectId);

      // Step 3: Store IDs in local state
      setProjectId(newProjectId);
      setEnvironmentId(newEnvironmentId);

      // Step 4: Update context with IDs
      setProject({
        ...formData,
        project_id: newProjectId,
        environment_id: newEnvironmentId
      });

      // Step 5: Mark project as completed
      setIsProjectCompleted(true);
     saveWizardData();


      // Step 6: Move to bitbucket section
      setCurrentSection('bitbucket');
      
      // toast.success('Project and environment created successfully');
    } catch (error) {
      console.error('Error in save and next:', error);
      toast.error(error.response?.data?.message || 'Failed to create project and environment. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const validateBitbucket = () => {
    const newErrors = {};
    if (!bitbucketUsername.trim()) {
      newErrors.username = 'Username is required';
    }
    if (!bitbucketAppPassword.trim()) {
      newErrors.appPassword = 'App password is required';
    }
    setBitbucketErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveBitbucketConfig = async () => {
    if (!validateBitbucket()) return;

    setIsLoading(true);
    try {
      const payload = {
        username: bitbucketUsername.trim(),
        app_password: bitbucketAppPassword.trim(),
      };

      await axiosInstance.post('/add_bitbucket_settings', payload);

      // Update context with bitbucket credentials
      setProject({
        ...projectData,
        bitbucketUsername: bitbucketUsername.trim(),
        bitbucketAppPassword: bitbucketAppPassword.trim(),
      });

      toast.success('Bitbucket credentials saved successfully');
      setIsBitbucketCompleted(true);

      // Move to repository section
      setCurrentSection('repository');
    } catch (error) {
      console.error('Error saving Bitbucket credentials:', error);
      const errorMessage =
        error.response?.data?.message || 'Failed to save Bitbucket credentials';
      toast.error(errorMessage, {
        position: 'top-right',
        duration: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateBitbucketConfig = async () => {
    if (!validateBitbucket()) return;

    setIsLoading(true);
    try {
      const payload = {
        username: bitbucketUsername.trim(),
        app_password: bitbucketAppPassword.trim(),
      };

      await axiosInstance.post('/add_bitbucket_settings', payload);

      // Update context with bitbucket credentials
      setProject({
        ...projectData,
        bitbucketUsername: bitbucketUsername.trim(),
        bitbucketAppPassword: bitbucketAppPassword.trim(),
      });

      toast.success('Bitbucket credentials updated successfully');
      setIsEditingBitbucket(false);
    } catch (error) {
      console.error('Error updating Bitbucket credentials:', error);
      const errorMessage =
        error.response?.data?.message || 'Failed to update Bitbucket credentials';
      toast.error(errorMessage, {
        position: 'top-right',
        duration: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditBitbucketClick = () => {
    setIsEditingBitbucket(true);
  };

  const handleCancelBitbucketEdit = () => {
    setBitbucketUsername(projectData.bitbucketUsername || '');
    setBitbucketAppPassword(projectData.bitbucketAppPassword || '');
    setBitbucketErrors({});
    setIsEditingBitbucket(false);
  };

  const validateRepository = () => {
    const newErrors = {};
    if (!selectedWorkspace) {
      newErrors.workspace = 'Workspace is required';
    }
    if (!selectedRepository) {
      newErrors.repository = 'Repository is required';
    }
    setRepositoryErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveRepository = async () => {
    if (!validateRepository()) return;

    setIsLoading(true);
    try {
      const selectedWs = workspaces.find((ws) => ws.slug === selectedWorkspace);
      const selectedRepo = repositories.find((repo) => repo.slug === selectedRepository);

      if (!selectedWs || !selectedRepo) {
        toast.error('Invalid workspace or repository selection', {
          position: 'top-right',
          duration: 3000,
        });
        setIsLoading(false);
        return;
      }

      const payload = {
        project_id: projectId,
        workspace_name: selectedWs.slug,
        repo_name: selectedRepo.slug,
      };

      await axiosInstance.post('/add_project_repo', payload);

      // Update context with repository details
      setProject({
        ...projectData,
        selectedWorkspace: selectedWs.slug,
        selectedRepository: selectedRepo.slug,
        workspaceName: selectedWs.name,
        repositoryName: selectedRepo.name,
      });

      toast.success('Repository linked successfully');
      setIsRepositoryCompleted(true);

      // Mark step 3 completed and step 4 in progress
      setStepCreatedEntityId(stepId, projectId);
      markStepCompleted(stepId);
      setStepStatus(4, STEP_STATUS.IN_PROGRESS);

      // Move to next step
      nextStep();
      saveWizardData();
      navigate('/app/onboarding?step=4');
    } catch (error) {
      console.error('Error saving repository link:', error);
      const errorMessage =
        error.response?.data?.message || 'Failed to link repository';
      toast.error(errorMessage, {
        position: 'top-right',
        duration: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateRepository = async () => {
    if (!validateRepository()) return;

    setIsLoading(true);
    try {
      const selectedWs = workspaces.find((ws) => ws.slug === selectedWorkspace);
      const selectedRepo = repositories.find((repo) => repo.slug === selectedRepository);

      if (!selectedWs || !selectedRepo) {
        toast.error('Invalid workspace or repository selection', {
          position: 'top-right',
          duration: 3000,
        });
        setIsLoading(false);
        return;
      }

      const payload = {
        project_id: projectId,
        workspace_name: selectedWs.slug,
        repo_name: selectedRepo.slug,
      };

      await axiosInstance.put('/update_project_repo', payload);

      // Update context with repository details
      setProject({
        ...projectData,
        selectedWorkspace: selectedWs.slug,
        selectedRepository: selectedRepo.slug,
        workspaceName: selectedWs.name,
        repositoryName: selectedRepo.name,
      });

      toast.success('Repository updated successfully');
      setIsEditingRepository(false);
    } catch (error) {
      console.error('Error updating repository link:', error);
      const errorMessage =
        error.response?.data?.message || 'Failed to update repository';
      toast.error(errorMessage, {
        position: 'top-right',
        duration: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditRepositoryClick = () => {
    setIsEditingRepository(true);
  };

  const handleCancelRepositoryEdit = () => {
    setSelectedWorkspace(projectData.selectedWorkspace || '');
    setSelectedRepository(projectData.selectedRepository || '');
    setRepositoryErrors({});
    setIsEditingRepository(false);
  };

  const handleEditProjectClick = () => {
    setStepMode(stepId, STEP_MODE.EDIT);
    setStepEditing(stepId, true, 'project');
  };

  const handleEditEnvironmentClick = () => {
    setStepMode(stepId, STEP_MODE.EDIT);
    setStepEditing(stepId, true, 'environment');
  };

  const handleUpdateProject = async () => {
    if (!validate('project')) return;

    setIsLoading(true);
    try {
      await updateProjectAPI(projectData.project_id);
      setStepEditing(stepId, false, null);
      saveWizardData();
      // toast.success('Project updated successfully');
    } catch (error) {
      console.error('Error updating project:', error);
      toast.error(error.response?.data?.message || 'Failed to update project. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateEnvironment = async () => {
    if (!validate('environment')) return;

    setIsLoading(true);
    try {
      await updateEnvironmentAPI(projectData.environment_id);
      setStepEditing(stepId, false, null);
      saveWizardData();
      // toast.success('Environment updated successfully');
    } catch (error) {
      console.error('Error updating environment:', error);
      toast.error(error.response?.data?.message || 'Failed to update environment. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelEdit = () => {
    // Reset form to original values
    setFormData({
      name: projectData.name || '',
      applicationType: projectData.applicationType || '',
      environment: projectData.environment || 'dev',
      baseUrl: projectData.baseUrl || '',
      apiBaseUrl: projectData.apiBaseUrl || '',
      appPackage: projectData.appPackage || '',
      iotCategory: projectData.iotCategory || '',
      iotConnectivity: projectData.iotConnectivity || '',
      iotTestEnvironment: projectData.iotTestEnvironment || ''
    });
    setErrors({});
    setStepEditing(stepId, false, null);
  };

  const handleSkipBitbucket = () => {
    setShowSkipBitbucketModal(true);
  };

  const handleConfirmSkipBitbucket = async () => {
    setIsLoading(true);
    try {
      // Update context with skip flag
      setProject({
        ...projectData,
        skip_bitbucket_flow: true,
      });

      toast.success('Bitbucket configuration skipped. You can configure it later from settings.');
      setShowSkipBitbucketModal(false);
      
      // Mark bitbucket as completed with skip flag
      setIsBitbucketCompleted(true);
      
      // Navigate to next step
      nextStep();
      markStepCompleted(stepId);
      setStepStatus(4, STEP_STATUS.IN_PROGRESS);
      navigate('/app/onboarding?step=4');
    } catch (error) {
      console.error('Error skipping bitbucket:', error);
      toast.error('Failed to skip bitbucket configuration');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelSkipBitbucket = () => {
    setShowSkipBitbucketModal(false);
  };

  const handleContinue = () => {
    if(currentSection === 'project') {
      setCurrentSection('bitbucket');
      return;
    }
    if(currentSection === 'bitbucket') {
      setCurrentSection('repository');
      return;
    }
    nextStep();
    navigate('/app/onboarding?step=4');
  };

  const handleBack = () => {
    // If in bitbucket section, go back to project section
    if (currentSection === 'bitbucket') {
      setCurrentSection('project');
    } 
    // If in repository section, go back to bitbucket section
    else if (currentSection === 'repository') {
      setCurrentSection('bitbucket');
    } 
    // From project section, go to previous step
    else {
      previousStep();
      navigate('/app/onboarding?step=2');
    }
  };

const handleConfirmAppType = () => {
  const appType = pendingAppType;

  setFormData(prev => ({ ...prev, applicationType: appType }));
  setIsAppTypeLocked(true);
  setShowAppTypeModal(false);

  // Sync to context
  setProject({ applicationType: appType });

  // Update step flow
  updateStepFlowByAppType(appType);
};

    const handleCancelAppType = () => {
    setPendingAppType('');
    setShowAppTypeModal(false);
  };

  return (
    <PrivateWizardLayout>
      <WizardContainer>
        <Stepper currentStep={3} completedSteps={engine.flow.completedSteps} />
        
        <WizardCard
          title={
            currentSection === 'project' 
              ? 'Set up your first project'
              : currentSection === 'bitbucket'
              ? 'Connect Bitbucket'
              : 'Link Repository'
          }
          subtitle={
            currentSection === 'project'
              ? 'Tell us what you are testing and where it runs.'
              : currentSection === 'bitbucket'
              ? 'Connect Bitbucket so generated scripts can be versioned in your repository.'
              : 'Choose the Bitbucket workspace and repository to store your scripts.'
          }
        >
          {/* PROJECT AND ENVIRONMENT SECTION */}
          {currentSection === 'project' && (
             <ProjectSection 
              showEditIcons={showEditIcons}
              isEditingProject={isEditingProject}
              isCreating={isCreating}
              handleCancelEdit={handleCancelEdit}
              isLoading={isLoading}
              handleUpdateProject={handleUpdateProject}
              formData={formData}
              handleChange={handleChange}
              isProjectFieldsDisabled={isProjectFieldsDisabled}
              errors={errors}
              isEditingEnvironment={isEditingEnvironment}
              handleUpdateEnvironment={handleUpdateEnvironment}
              isEnvironmentFieldsDisabled={isEnvironmentFieldsDisabled}
              handleSaveAndNext={handleSaveAndNext}
              handleContinue={handleContinue}
              handleBack={handleBack}
              handleEditProjectClick={handleEditProjectClick}
              handleEditEnvironmentClick={handleEditEnvironmentClick}
              isAppTypeLocked={isAppTypeLocked}
             
             />
          )}

          {/* BITBUCKET CONFIGURATION SECTION */}
          {currentSection === 'bitbucket' && (
      <BitbucketSection
  isBitbucketCompleted={isBitbucketCompleted}
  isEditingBitbucket={isEditingBitbucket}
  handleEditBitbucketClick={handleEditBitbucketClick}
  handleCancelBitbucketEdit={handleCancelBitbucketEdit}
  isLoading={isLoading}
  handleUpdateBitbucketConfig={handleUpdateBitbucketConfig}
  bitbucketUsername={bitbucketUsername}
  bitbucketAppPassword={bitbucketAppPassword}
  setBitbucketUsername={setBitbucketUsername}
  bitbucketErrors={bitbucketErrors}
  setBitbucketErrors={setBitbucketErrors}
  setBitbucketAppPassword={setBitbucketAppPassword}
  handleBack={handleBack}
  handleSaveBitbucketConfig={handleSaveBitbucketConfig}
  setCurrentSection={setCurrentSection}
  handleSkipBitbucket={handleSkipBitbucket}
/>
     
          )}

          {/* REPOSITORY SELECTION SECTION */}
          {currentSection === 'repository' && (
             <RepositorySection
              isRepositoryCompleted={isRepositoryCompleted}
              isEditingRepository={isEditingRepository}
              selectedWorkspace={selectedWorkspace}
              selectedRepository={selectedRepository}
              workspaces={workspaces}
              repositoryErrors={repositoryErrors}
              fetchingWorkspaces={fetchingWorkspaces}
              isLoading={isLoading}
              handleEditRepositoryClick={handleEditRepositoryClick}
              handleCancelRepositoryEdit={handleCancelRepositoryEdit}
              handleUpdateRepository={handleUpdateRepository}
              setSelectedWorkspace={setSelectedWorkspace}
              setRepositoryErrors={setRepositoryErrors}
              setSelectedRepository={setSelectedRepository}
              fetchingRepos={fetchingRepos}
              repositories={repositories}
              handleBack={handleBack}
              handleSaveRepository={handleSaveRepository}
              nextStep={nextStep}
              navigate={navigate}
             />
          )}
    
        </WizardCard>
          </WizardContainer>
          {showAppTypeModal && (
            <ConfirmAppTypeModal
              handleCancelAppType={handleCancelAppType}
              handleConfirmAppType={handleConfirmAppType}
              appTypeLabel={APP_TYPE_LABELS[pendingAppType]}
            />
)}
          {showSkipBitbucketModal && (
            <OnboardingModal
              title="Skip this step?"
              description="You can configure Bitbucket later from Settings."
              icon={<LuSkipForward size={20} />}
              tone="info"
              size="sm"
              dismissible={false}
              busy={isLoading}
              footer={
                <>
                  <button
                    type="button"
                    className="ob-btn ob-btn--secondary"
                    onClick={handleCancelSkipBitbucket}
                    disabled={isLoading}
                    data-autofocus
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="ob-btn ob-btn--primary"
                    onClick={handleConfirmSkipBitbucket}
                    disabled={isLoading}
                  >
                    {isLoading && <span className="ob-spinner" aria-hidden="true" />}
                    {isLoading ? 'Skipping...' : 'Skip for now'}
                  </button>
                </>
              }
            >
              <p>
                Without Bitbucket, generated scripts won&apos;t be pushed to a repository automatically.
              </p>
            </OnboardingModal>
          )}
      
    </PrivateWizardLayout>
  );
};

export default Step3Project;


    const ProjectSection =({showEditIcons, isEditingProject, 
      isCreating,handleCancelEdit,isLoading,handleUpdateProject,
      formData,
      handleChange,
      isProjectFieldsDisabled,
      errors,
      isEditingEnvironment,
      handleUpdateEnvironment,
      isEnvironmentFieldsDisabled,
      handleSaveAndNext,
      handleContinue,
      handleBack,
      handleEditProjectClick,
      handleEditEnvironmentClick,
      isAppTypeLocked
    })=>{
      return (
            <>
              {/* Project Section Header with Edit Icon */}
              {showEditIcons && !isEditingProject && !isCreating && (
                <div className="wizard-project-section-header">
                  <div></div>
                  <button
                    onClick={handleEditProjectClick}
                    className="wizard-project-edit-btn"
                    title="Edit project settings"
                  >
                    <LuPencil size={16} />
                    Edit
                  </button>
                </div>
              )}

              {isEditingProject && (
                <div className="wizard-project-section-header">
                  <div></div>
                  <div className="wizard-project-edit-actions">
                    <button
                      className="wizard-project-edit-btn secondary"
                      onClick={handleCancelEdit}
                      disabled={isLoading}
                    >
                      Cancel
                    </button>
                    <button
                      className="wizard-project-edit-btn primary"
                      onClick={handleUpdateProject}
                      disabled={!formData.name.trim() || !formData.applicationType || isLoading}
                    >
                      {isLoading ? 'Updating...' : 'Update'}
                    </button>
                  </div>
                </div>
              )}

              {/* Project Section */}
              <div className="wizard-form-row">
                <div className="wizard-form-group">
                  <label className="wizard-form-label" htmlFor="ob-proj-name">
                    Project Name <span className="required">*</span>
                  </label>
                  <input
                    id="ob-proj-name"
                    type="text"
                    name="name"
                    aria-invalid={Boolean(errors.name) || undefined}
                    className={`wizard-form-input ${errors.name ? 'error' : ''}`}
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="e.g., E-commerce Web App"
                    disabled={isProjectFieldsDisabled || isLoading}
                  />
                  {errors.name && <p className="wizard-form-error">{errors.name}</p>}
                </div>

                <div className="wizard-form-group">
                  <label className="wizard-form-label" id="ob-proj-apptype-label">
                    Application Type <span className="required">*</span>
                  </label>
                  <WizardSelect
                    name="applicationType"
                    value={formData.applicationType}
                    onChange={handleChange}
                    disabled={isProjectFieldsDisabled || isAppTypeLocked || isLoading}
                    invalid={Boolean(errors.applicationType)}
                    aria-labelledby="ob-proj-apptype-label"
                  >
                    <option value="">Select application type</option>
                    <option value="web">Web Application</option>
                    <option value="API_BACKEND">API / Backend</option>
                    <option value="mobile" disabled>Mobile Application</option>
                    <option value="iot_hardware" >IoT / Hardware</option>
                  </WizardSelect>
                  {isAppTypeLocked && !errors.applicationType && (
                    <p className="wizard-form-help">Application type is locked once confirmed.</p>
                  )}
                  {errors.applicationType && <p className="wizard-form-error">{errors.applicationType}</p>}
                </div>
              </div>

              {/* Environment Section Header with Edit Icon */}
              {showEditIcons && !isEditingEnvironment && !isCreating && (
                <div className="wizard-project-section-header" style={{ marginTop: '2rem' }}>
                  <div></div>
                  <button
                    onClick={handleEditEnvironmentClick}
                    className="wizard-project-edit-btn"
                    title="Edit environment settings"
                  >
                    <LuPencil size={16} />
                    Edit
                  </button>
                </div>
              )}

              {isEditingEnvironment && (
                <div className="wizard-project-section-header" style={{ marginTop: '2rem' }}>
                  <div></div>
                  <div className="wizard-project-edit-actions">
                    <button
                      className="wizard-project-edit-btn secondary"
                      onClick={handleCancelEdit}
                      disabled={isLoading}
                    >
                      Cancel
                    </button>
                    <button
                      className="wizard-project-edit-btn primary"
                      onClick={handleUpdateEnvironment}
                      disabled={!formData.environment || isLoading}
                    >
                      {isLoading ? 'Updating...' : 'Update'}
                    </button>
                  </div>
                </div>
              )}

              {/* Environment Section */}
              <div className="wizard-form-row">
                <div className="wizard-form-group">
                  <label className="wizard-form-label" id="ob-proj-env-label">
                    Environment <span className="required">*</span>
                  </label>
                  <WizardSelect
                    name="environment"
                    value={formData.environment}
                    onChange={handleChange}
                    disabled={isEnvironmentFieldsDisabled || isLoading}
                    invalid={Boolean(errors.environment)}
                    aria-labelledby="ob-proj-env-label"
                  >
                    <option value="dev">Development</option>
                    <option value="qa">QA / Testing</option>
                    <option value="uat">UAT / Staging</option>
                    <option value="prod" >Production</option>
                  </WizardSelect>
                  {errors.environment && <p className="wizard-form-error">{errors.environment}</p>}
                </div>

                {/* Conditional fields based on app type - in same row */}
                {formData.applicationType === 'web' && (
                  <div className="wizard-form-group">
                    <label className="wizard-form-label">
                      Base URL <span className="required">*</span>
                    </label>
                    <input
                      type="url"
                      name="baseUrl"
                      className="wizard-form-input"
                      value={formData.baseUrl}
                      onChange={handleChange}
                      placeholder="https://example.com"
                      disabled={isEnvironmentFieldsDisabled || isLoading}
                    />
                    {errors.baseUrl && <p className="wizard-form-error">{errors.baseUrl}</p>}
                    <p className="wizard-form-help">
                      Main application URL
                    </p>
                  </div>
                )}

                {formData.applicationType === 'API_BACKEND' && (
                  <div className="wizard-form-group">
                    <label className="wizard-form-label">
                      API Base URL <span className="required">*</span>
                    </label>
                    <input
                      type="url"
                      name="apiBaseUrl"
                      className="wizard-form-input"
                      value={formData.apiBaseUrl}
                      onChange={handleChange}
                      placeholder="https://api.example.com/v1"
                      disabled={isEnvironmentFieldsDisabled || isLoading}
                    />
                    {errors.apiBaseUrl && <p className="wizard-form-error">{errors.apiBaseUrl}</p>}
                    <p className="wizard-form-help">
                      Base URL for API endpoints
                    </p>
                  </div>
                )}

                {formData.applicationType === 'mobile' && (
                  <div className="wizard-form-group">
                    <label className="wizard-form-label">
                      App Package / Bundle ID
                    </label>
                    <input
                      type="text"
                      name="appPackage"
                      className="wizard-form-input"
                      value={formData.appPackage}
                      onChange={handleChange}
                      placeholder="com.example.app"
                      disabled={isEnvironmentFieldsDisabled || isLoading}
                    />
                    <p className="wizard-form-help">
                      Package name or bundle identifier
                    </p>
                  </div>
                )}

                {formData.applicationType === 'iot_hardware' && (
                  <>
                    <div className="wizard-form-group">
                      <label className="wizard-form-label" id="ob-proj-iotcat-label">
                        Device Category
                      </label>
                      <WizardSelect
                        name="iotCategory"
                        value={formData.iotCategory}
                        onChange={handleChange}
                        disabled={isEnvironmentFieldsDisabled || isLoading}
                        aria-labelledby="ob-proj-iotcat-label"
                      >
                        <option value="">Select category</option>
                        <option value="smart_lock">Smart Lock</option>
                        <option value="sensor">Sensor</option>
                        <option value="switch">Switch</option>
                        <option value="camera">Camera</option>
                        <option value="controller">Controller</option>
                        <option value="other">Other</option>
                      </WizardSelect>
                      <p className="wizard-form-help">
                        Type of IoT device being tested
                      </p>
                    </div>
                  </>
                )}

                {!formData.applicationType && (
                  <div className="wizard-form-group">
                    <div className="ob-empty-hint">
                      Select an application type to see environment details
                    </div>
                  </div>
                )}
              </div>

              {/* IoT additional fields - third row */}
              {formData.applicationType === 'iot_hardware' && (
                <div className="wizard-form-row">
                  <div className="wizard-form-group">
                    <label className="wizard-form-label" id="ob-proj-iotconn-label">
                      Connectivity
                    </label>
                    <WizardSelect
                      name="iotConnectivity"
                      value={formData.iotConnectivity}
                      onChange={handleChange}
                      disabled={isEnvironmentFieldsDisabled || isLoading}
                      aria-labelledby="ob-proj-iotconn-label"
                    >
                      <option value="">Select connectivity</option>
                      <option value="wifi">Wi-Fi</option>
                      <option value="ble">Bluetooth LE</option>
                      <option value="zigbee">Zigbee</option>
                      <option value="ethernet">Ethernet</option>
                      <option value="lora">LoRa</option>
                      <option value="other">Other</option>
                    </WizardSelect>
                    <p className="wizard-form-help">
                      Device communication protocol
                    </p>
                  </div>

                  <div className="wizard-form-group">
                    <label className="wizard-form-label" id="ob-proj-iotenv-label">
                      Test Environment
                    </label>
                    <WizardSelect
                      name="iotTestEnvironment"
                      value={formData.iotTestEnvironment}
                      onChange={handleChange}
                      disabled={isEnvironmentFieldsDisabled || isLoading}
                      aria-labelledby="ob-proj-iotenv-label"
                    >
                      <option value="">Select environment</option>
                      <option value="lab">Lab</option>
                      <option value="field">Field</option>
                      <option value="hybrid">Hybrid (Lab + Field)</option>
                    </WizardSelect>
                    <p className="wizard-form-help">
                      Where tests will be executed
                    </p>
                  </div>
                </div>
              )}

              {/* Action Buttons */}
              <div className="wizard-project-actions">
                <button
                  type="button"
                  className="back"
                  onClick={handleBack}
                  disabled={isLoading}
                >
                  <LuArrowLeft size={16} aria-hidden="true" />
                  Back
                </button>

                {isCreating ? (
                  <button
                    className="primary"
                    onClick={handleSaveAndNext}
                    disabled={!formData.name.trim() || !formData.applicationType || isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span className="ob-spinner" aria-hidden="true" />
                        Saving...
                      </>
                    ) : (
                      'Save'
                    )}
                  </button>
                ) : (
                  <button
                    className="primary"
                    onClick={handleContinue}
                  >
                    Continue
                  </button>
                )}
              </div>
            </>
          )
}


  const BitbucketSection=({isBitbucketCompleted,
    isEditingBitbucket,handleEditBitbucketClick,
    handleCancelBitbucketEdit,
    isLoading,
    handleUpdateBitbucketConfig,
    bitbucketUsername,
    bitbucketAppPassword,
    setBitbucketUsername,
    bitbucketErrors,
    setBitbucketErrors,
    setBitbucketAppPassword,
    handleBack,
    handleSaveBitbucketConfig,
    setCurrentSection,
    handleSkipBitbucket
    })=>{
      return (
              <>
                {/* Edit Icon - Show when bitbucket is completed and not editing */}
                {isBitbucketCompleted && !isEditingBitbucket && (
                  <div className="wizard-project-section-header">
                    <div></div>
                    <button
                      onClick={handleEditBitbucketClick}
                      className="wizard-project-edit-btn"
                      title="Edit Bitbucket settings"
                    >
                      <LuPencil size={16} />
                      Edit
                    </button>
                  </div>
                )}

                {/* Edit Actions - Show when editing */}
                {isEditingBitbucket && (
                  <div className="wizard-project-section-header">
                    <div></div>
                    <div className="wizard-project-edit-actions">
                      <button
                        className="wizard-project-edit-btn secondary"
                        onClick={handleCancelBitbucketEdit}
                        disabled={isLoading}
                      >
                        Cancel
                      </button>
                      <button
                        className="wizard-project-edit-btn primary"
                        onClick={handleUpdateBitbucketConfig}
                        disabled={!bitbucketUsername.trim() || !bitbucketAppPassword.trim() || isLoading}
                      >
                        {isLoading ? 'Updating...' : 'Update'}
                      </button>
                    </div>
                  </div>
                )}

                {/* Username and App Password Input */}
                <div className="wizard-form-row">
                  <div className="wizard-form-group">
                    <label className="wizard-form-label" htmlFor="ob-bb-username">
                      Username <span className="required">*</span>
                    </label>
                    <input
                      id="ob-bb-username"
                      autoComplete="username"
                      type="text"
                      value={bitbucketUsername}
                      onChange={(e) => {
                        setBitbucketUsername(e.target.value);
                        if (bitbucketErrors.username) {
                          setBitbucketErrors((prev) => ({ ...prev, username: '' }));
                        }
                      }}
                      disabled={isBitbucketCompleted && !isEditingBitbucket ? true : isLoading}
                      placeholder="Enter Bitbucket username"
                      className={`wizard-form-input ${
                        bitbucketErrors.username ? 'error' : ''
                      }`}
                    />
                    {bitbucketErrors.username && (
                      <p className="wizard-form-error">{bitbucketErrors.username}</p>
                    )}
                  </div>

                  <div className="wizard-form-group">
                    <label className="wizard-form-label" htmlFor="ob-bb-app-password">
                      App Password <span className="required">*</span>
                    </label>
                    <input
                      id="ob-bb-app-password"
                      autoComplete="new-password"
                      type="password"
                      value={bitbucketAppPassword}
                      onChange={(e) => {
                        setBitbucketAppPassword(e.target.value);
                        if (bitbucketErrors.appPassword) {
                          setBitbucketErrors((prev) => ({ ...prev, appPassword: '' }));
                        }
                      }}
                      disabled={isBitbucketCompleted && !isEditingBitbucket ? true : isLoading}
                      placeholder="Enter Bitbucket app password"
                      className={`wizard-form-input ${
                        bitbucketErrors.appPassword ? 'error' : ''
                      }`}
                    />
                    {bitbucketErrors.appPassword && (
                      <p className="wizard-form-error">{bitbucketErrors.appPassword}</p>
                    )}
                  </div>
                </div>

                {/* Info Accordion - Why Configure Bitbucket */}
                <details className="ob-disclosure">
                  <summary>
                    <LuInfo size={16} className="ob-disclosure__icon" aria-hidden="true" />
                    Why connect Bitbucket?
                    <LuChevronDown size={16} className="ob-disclosure__chevron" aria-hidden="true" />
                  </summary>
                  <div className="ob-disclosure__content">
                    <p>
                      <strong>Bitbucket configuration</strong> allows you to save test case scripts and automation code directly to your Bitbucket repository. This enables:
                    </p>
                    <ul>
                      <li>Automatic version control of your test scripts</li>
                      <li>Easy collaboration with your team</li>
                      <li>Integration with your CI/CD pipeline</li>
                      <li>Better tracking of changes and history</li>
                    </ul>
                    <p style={{ marginBottom: 0 }}>
                      You can configure this later from the <strong>Settings</strong> page in the application if you prefer to skip it now.
                    </p>
                  </div>
                </details>

                {/* Action Buttons */}
                <div className="wizard-project-actions">
                  <button
                    type="button"
                    className="back"
                    onClick={handleBack}
                    disabled={isLoading}
                  >
                    <LuArrowLeft size={16} aria-hidden="true" />
                    Back
                  </button>

                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', justifyContent: 'flex-end' }}>
                    {!isBitbucketCompleted && (
                      <button
                        type="button"
                        className="secondary"
                        onClick={handleSkipBitbucket}
                        disabled={isLoading}
                      >
                        Skip for now
                      </button>
                    )}
                    {!isBitbucketCompleted ? (
                      <button
                        className="primary"
                        onClick={handleSaveBitbucketConfig}
                        disabled={!bitbucketUsername.trim() || !bitbucketAppPassword.trim() || isLoading}
                      >
                        {isLoading ? (
                          <>
                            <span className="ob-spinner" aria-hidden="true" />
                            Saving...
                          </>
                        ) : (
                          'Save Configuration'
                        )}
                      </button>
                    ) : (
                      <button
                        className="primary"
                        onClick={() => setCurrentSection('repository')}
                        disabled={isLoading}
                      >
                        Continue
                      </button>
                    )}
                  </div>
                </div>

              </>
            )
  }

  const RepositorySection =({isRepositoryCompleted, isEditingRepository,
     selectedWorkspace, selectedRepository, workspaces, repositoryErrors, 
    fetchingWorkspaces, isLoading, handleEditRepositoryClick, 
    handleCancelRepositoryEdit, 
    handleUpdateRepository,setSelectedWorkspace,
   setRepositoryErrors, setSelectedRepository, fetchingRepos, 
   repositories, handleBack, handleSaveRepository, nextStep, navigate
  })=>{
     return (
            <>
              {/* Edit Icon - Show when repository is completed and not editing */}
              {isRepositoryCompleted && !isEditingRepository && (
                <div className="wizard-project-section-header">
                  <div></div>
                  <button
                    onClick={handleEditRepositoryClick}
                    className="wizard-project-edit-btn"
                    title="Edit Repository settings"
                  >
                    <LuPencil size={16} />
                    Edit
                  </button>
                </div>
              )}

              {/* Edit Actions - Show when editing */}
              {isEditingRepository && (
                <div className="wizard-project-section-header">
                  <div></div>
                  <div className="wizard-project-edit-actions">
                    <button
                      className="wizard-project-edit-btn secondary"
                      onClick={handleCancelRepositoryEdit}
                      disabled={isLoading}
                    >
                      Cancel
                    </button>
                    <button
                      className="wizard-project-edit-btn primary"
                      onClick={handleUpdateRepository}
                      disabled={!selectedWorkspace || !selectedRepository || isLoading}
                    >
                      {isLoading ? 'Updating...' : 'Update'}
                    </button>
                  </div>
                </div>
              )}

              {/* Workspace Dropdown and Repository Dropdown */}
              <div className="wizard-form-row">
                <div className="wizard-form-group">
                  <label className="wizard-form-label" id="ob-repo-ws-label">
                    Workspace Name <span className="required">*</span>
                  </label>
                  <WizardSelect
                    aria-labelledby="ob-repo-ws-label"
                    invalid={Boolean(repositoryErrors.workspace)}
                    value={selectedWorkspace}
                    onChange={(e) => {
                      setSelectedWorkspace(e.target.value);
                      if (repositoryErrors.workspace) {
                        setRepositoryErrors((prev) => ({ ...prev, workspace: '' }));
                      }
                    }}
                    disabled={isRepositoryCompleted && !isEditingRepository ? true : (isLoading || fetchingWorkspaces)}
                  >
                    <option value="">
                      {fetchingWorkspaces ? 'Loading workspaces...' : 'Select workspace'}
                    </option>
                    {workspaces.map((ws) => (
                      <option key={ws.uuid} value={ws.slug}>
                        {ws.slug}
                      </option>
                    ))}
                  </WizardSelect>
                  {repositoryErrors.workspace && (
                    <p className="wizard-form-error">{repositoryErrors.workspace}</p>
                  )}
                </div>

                <div className="wizard-form-group">
                  <label className="wizard-form-label" id="ob-repo-name-label">
                    Repository Name <span className="required">*</span>
                  </label>
                  <WizardSelect
                    aria-labelledby="ob-repo-name-label"
                    invalid={Boolean(repositoryErrors.repository)}
                    value={selectedRepository}
                    onChange={(e) => {
                      setSelectedRepository(e.target.value);
                      if (repositoryErrors.repository) {
                        setRepositoryErrors((prev) => ({ ...prev, repository: '' }));
                      }
                    }}
                    disabled={isRepositoryCompleted && !isEditingRepository ? true : (isLoading || fetchingRepos || !selectedWorkspace)}
                  >
                    <option value="">
                      {!selectedWorkspace
                        ? 'Select workspace first'
                        : fetchingRepos
                        ? 'Loading repositories...'
                        : 'Select repository'}
                    </option>
                    {repositories.map((repo) => (
                      <option key={repo.slug} value={repo.slug}>
                        {repo.name}
                      </option>
                    ))}
                  </WizardSelect>
                  {repositoryErrors.repository && (
                    <p className="wizard-form-error">{repositoryErrors.repository}</p>
                  )}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="wizard-project-actions">
                <button
                  type="button"
                  className="back"
                  onClick={handleBack}
                  disabled={isLoading}
                >
                  <LuArrowLeft size={16} aria-hidden="true" />
                  Back
                </button>

                {!isRepositoryCompleted ? (
                  <button
                    className="primary"
                    onClick={handleSaveRepository}
                    disabled={!selectedWorkspace || !selectedRepository || isLoading || fetchingWorkspaces || fetchingRepos}
                  >
                    {isLoading ? (
                      <>
                        <span className="ob-spinner" aria-hidden="true" />
                        Saving...
                      </>
                    ) : (
                      'Save and Next'
                    )}
                  </button>
                ) : (
                  <button
                    className="primary"
                    onClick={() => {
                      nextStep();
                      navigate('/app/onboarding?step=4');
                    }}
                    disabled={isLoading}
                  >
                    Continue
                  </button>
                )}
              </div>
            </>
          )
  }